import { createContext, useContext } from "react"
import { ConversationContext } from "@/types"

export interface PlaygroundChatContextType {
  conversationContext: ConversationContext | null
  setConversationContext: (context: ConversationContext | null) => void
}

export const PlaygroundChatContext =
  createContext<PlaygroundChatContextType | null>(null)

export const usePlaygroundChatContext = () => {
  const context = useContext(PlaygroundChatContext)
  if (!context) {
    throw new Error(
      "usePlaygroundChatContext must be used within a PlaygroundChatContext"
    )
  }
  return context
}
